export const h = {		
	login:{		
			login:"Đăng nhập",
			pleaseusername:"Vui lòng nhập tên người dùng",
			pleasepassword:"Xin vui lòng nhập mật khẩu",
			checkname:"Vui lòng nhập đúng tên người dùng",
			checkpass:"Mật khẩu không được ít hơn 3 ký tự",
		},	
	navbar:{	
		home:"trang đầu",
		mycenter:"Trung tâm cá nhân",
		outlogin:"từ bỏ",
		close:"Khép kín",
		editLanguage:"ngôn ngữ soạn thảo",
	},	
	vip:{	
		nickname:"tên nick",
		pleasenickname:"Hãy nhập một nickname",
		username:"tên tài khoản",
		pleaseusername:"Vui lòng nhập tên người dùng",
		arealogin:"Khu vực đăng nhập",
		pleasearealogin:"Vui lòng nhập khu vực đăng nhập của bạn",
		nationality:"Quốc tịch",
		pleasenationality:"Vui lòng chọn quốc tịch",
		depositstatus:"Trạng thái tiền gửi",
		pleasedepositstatus:"Vui lòng chọn trạng thái tiền gửi",
		createtime:"thời gian sáng tạo",
		logintime:"Thời gian đăng nhập",
		startime:"Thời gian bắt đầu",
		endtime:"Thời gian kết thúc",
		no:"số seri",
		shangji:"Đề xuất trực tiếp lên cấp trên",
		keyongmoney:"Số dư khả dụng",
		baozhengjing:"lề",
		fudongyingkui:"Lãi lỗ thả nổi",
		zicantotal:"Tổng tài sản",
		yaoqingma:"Mã mời",
		zongrujing:"tổng tiền gửi",
		zongchujing:"Tổng số tiền rút",
		loginIp:"địa chỉ đăng nhập",
		zuihoulogin:"lần đăng nhập cuối cùng",
		shoucirujingmoney:"Số tiền gửi lần đầu",
		shoucirujingtime:"Lần gửi tiền đầu tiên",
		kaitongtime:"Thời gian mở cửa",
		keyong:"Có sẵn",
		daoshi:"gia sư",
		dongjie:"đông cứng",
		chujingstate:"Trạng thái rút tiền",
		xiajichujingstate:"Trạng thái rút tiền cấp thấp hơn",
		caozuo:"vận hành",
		chakan:"Kiểm tra",
		heji:"tổng cộng",
		moneytotal:"tổng số dư",
		paixu:"loại",
		daochu:"Xuất khẩu",
		huiyuanguanli:"Quản lý thành viên",
		yonghu:"người dùng",
		search:"Tìm kiếm truy vấn",
		reset:"cài lại",
		delete:"xóa bỏ",
		kickout:"đuổi ra ngoài",
		notlogin:"Chưa đăng nhập",
		editLanguage:"ngôn ngữ soạn thảo",
		yourujing:"Có tiền đặt cọc",
		wurujing:"Không cần đặt cọc",
    todayreg: "Lượng đăng ký trong ngày hôm nay: ",
    newvipnum: "Số lượng thành viên VIP mới tham gia: ",
    juese: "vai trò",
    xiugaimima: "đổi mật khẩu",
    jiumima: "mật khẩu cũ",
    shurujiumima: "nhập mật khẩu cũ",
    xinmima: "mật khẩu mới",
    shuruxinmima: "nhập mật khẩu mới",
    gerenzhongxing: "trung tâm cá nhân",
    yonghuxinxi: "thông tin người dùng",
	remark: "ghi chú",
	},	
	info:{	
		home:"Trang chủ",
		user:"tên người dùng",
		nickname:"tên nick",
		account:"tài khoản",
		identity:"số ID",
		phone:"số điện thoại",
		nationality:"Quốc tịch",
		Balance:"Quản lý số dư",
		real:"Tài khoản thực",
		zhongmongy:"tổng số dư",
		keyongmoney:"Số dư khả dụng",
		jiaoyidongjie:"Giao dịch bị đóng băng",
		shishilirun:"lợi nhuận theo thời gian thực",
		shishikeyong:"Có sẵn trong thời gian thực",
		xunizhanghu:"tài khoản ảo",
		churujinguanli:"Quản lý tiền gửi và rút tiền",
		chakanzijinjilu:"Xem lịch sử quỹ",
		rujinjilu:"Hồ sơ gửi tiền",
		rujinjine:"Số tiền gửi",
		jiaoyibishu:"Số lượng giao dịch",
		chujinjilu:"Hồ sơ rút tiền",
		chujinjine:"Số tiền rút",
		jiaoyiguanli:"Quản lý giao dịch",
		lishijilu:"kỷ lục lịch sử",
		chakanlishi:"Xem thông tin giao dịch lịch sử",
		jiaoyishoushu:"Lô giao dịch",
		jiaoyiyingkui:"Lãi lỗ giao dịch",
		dangqianchicang:"Vị trí hiện tại",
		chakandangqianchicang:"Xem thông tin vị trí hiện tại",
		dangqianguadan:"Lệnh chờ hiện tại",
		chakanguadanliebiao:"Xem danh sách lệnh chờ xử lý",
		guadanbishu:"Số lượng lệnh chờ xử lý",
		yongjinguanli:"Quản lý hoa hồng",
		duanwei:"thứ hạng",
		wu:"không có",
		zhishushangji:"Cấp trên trực tiếp",
		shangjidaili:"Đại lý cấp trên",
		xiajituandui:"Đội cấp dưới",
		shurudailiname:"Vui lòng nhập tên đại lý",
		chakan:"Kiểm tra",
		fanyongjie:"Số tiền hoàn lại",
		fanyongbishu:"Số lần giảm giá",
		chakanyongjinjilu:"Xem hồ sơ giảm giá",
		chakanyonghuinfo:"Xem chi tiết người dùng",
		chakanwenjuan:"Xem bảng câu hỏi",
		resetpassword:"đặt lại mật khẩu",
		sendmsg:"gửi tin nhắn",
		update:"Ôn lại",
		unbound:"Không giới hạn",
		weishiming:"Không xác thực tên thật",
		gendan:"Quản lý tài liệu",
		gensui:"theo",
		chakangendan:"Xem hồ sơ đơn hàng",
		dingdanhao:"số thứ tự",
		shoudongpay:"Nạp tiền thủ công",
		chakanyongjingjilu:"Xem lịch sử hoa hồng",
		xiugaiyonghuxinxi:"Sửa đổi thông tin người dùng",
		queding:"Chắc chắn",
		quxiao:"Hủy bỏ",
		email:"Thư",
		selguoji:"Vui lòng chọn quốc tịch",
		sendusermsg:"Gửi tin nhắn cho người dùng",
		title:"tiêu đề",
		shurutitle:"Vui lòng nhập tiêu đề tin nhắn",
		content:"nội dung",
		shurucontent:"Vui lòng nhập nội dung tin nhắn",
		zhenshi:"thực tế",
		xuni:"ảo",
		fangxiang:"phương hướng",
		zhanghu:"Tài khoản",
		add:"Tăng",
		less:"khấu trừ",
		type:"kiểu",
		guanliyuanpay:"Nạp tiền cho quản trị viên",
		pay:"nạp tiền",
		money:"Số lượng",
		updategdmsg:"Sửa thông tin đơn hàng",
		xinhaoyuan:"nguồn tín hiệu",
		yes:"Đúng",
		no:"KHÔNG",
		updateyongjingmsg:"Sửa đổi thông tin hoa hồng",
		qingxuanzejuese:"Vui lòng chọn vai trò tài khoản",
		zuoduo:"Đi lâu",
		zuokong:"ngắn",
		gensuinicheng:"theo dõi biệt hiệu",
		kaicangjia:"giá mở cửa",
		pingcangjia:"Giá đóng cửa",
		shousu:"Kích thước lô",
		pingcangdate:"Ngày mở vị thế",
		kaicangdate:"Ngày đóng cửa",
		chakangensuiinfo:"Xem chi tiết theo dõi",
		gensuiuserno:"Theo dõi số người dùng",
		gensuiyonghuname:"Theo dõi biệt hiệu của người dùng",
		gensuifangshji:"làm theo phương pháp",
		number:"Số lượng",
		danwei:"đơn vị",
		zhengxiang:"phía trước",
		fanxaing:"đảo ngược",
		beishu:"nhiều",
		shousu:"Kích thước lô",
		gensuizhuangtai:"theo dõi trạng thái",
		genjinzhong:"Ứng dụng đang theo dõi",
		gensuiok:"Đồng ý theo dõi",
		gensuino:"Từ chối được theo dõi",
		chexiao:"Hủy bỏ",
		gensuidate:"theo dõi thời gian",
		chakanlishijiaoyi:"Xem thông tin giao dịch lịch sử",
		chakanguadanlist:"Xem danh sách lệnh chờ xử lý",
		heyue:"hợp đồng",
		daili:"diễn xuất",
		huiyuanname:"Tên thành viên",
		xianjia:"giới hạn giá",
		zhisun:"chặn đứng tổn thất",
		guadanjia:"giá lệnh chờ xử lý",
		zhiyingzhisun:"Chốt lãi và dừng lỗ",
		zhiyingjia:"Lấy giá lãi",
		zhiyinghuichejia:"Lấy giá thoái lui lợi nhuận",
		zhisunjia:"Giá dừng lỗ",
		zhisunhuichejia:"Giá thoái lui dừng lỗ",
		weiset:"không được thiết lập",
		zt:"tình trạng",
		chakanchicangmsg:"Xem thông tin vị trí hiện tại",
		shouyiId:"ID người thụ hưởng",
		xiajiid:"ID người dùng cấp dưới",
		xiajiuser:"Tên người dùng cấp dưới",
		fanyongmonney:"Số tiền hoàn lại",
		tuihuibaozhengjing:"Trả lại tiền đặt cọc",
		shouxufei:"phí xử lý",
		shouyi:"thu nhập",
		lixi:"Quan tâm",
		zengmoney:"thưởng",
		zhuijiabaozhengjing:"lệnh gọi ký quỹ",
		fanyong:"Hạ giá",
		rujing:"Tiền gửi",
		chujing:"Rút tiền",
		chujingshibai:"Hoàn tiền nếu xem xét rút tiền không thành công",
		guanliyuanless:"Khấu trừ quản trị viên",
		pingzhong:"Đa dạng",
		shengqingzhong:"Áp dụng",
		wancheng:"Hoàn thành",
		chongzhimima:"Đặt lại mật khẩu thành công",
		copy:"sao chép",
		zhanghaomima:"mật khẩu tài khoản",
		fenye:"Bài viết / Trang",
    tixianmima:"Rút mật khẩu",
		gong:"chung",
		tiao:"dải",
		ye:"Trang",
		goto:"Đi đến",
		outtitle:"Bạn đã đăng xuất. Bạn có thể hủy và ở lại trang này hoặc đăng nhập lại.",
		outok:"OK để đăng xuất",
		chongxingdenglu:"đăng ký lại",
		cancel:"Hủy bỏ",
		pingtai:"nền tảng",
		nodata:"Không có dữ liệu",
    shangjiID: "ID cấp trên",
    shangjiaccount: "Tài khoản cấp trên",
    shangjiname: "Tên hiển thị cấp trên",
    shangjinickname: "Tên thật cấp trên",
    zhongyingkui: "Tổng lợi nhuận/lỗ",
    fuying: "Lợi nhuận nổi",
    yue: "Số dư",
    sheng: "Sắp xếp tăng dần",
    jiang: "Sắp xếp giảm dần"
	},	
	history:{		
			guadan:"Lợi nhuận và thua lỗ",
			shijia:"danh sách hàng chờ",
			gendan:"Giá thị trường",
			dangqianjia:"Làm theo đơn đặt hàng",
			geyelixi:"giá hiện tại",
			weituodate:"lãi suất qua đêm",
			pingcangfangshi:"Thời gian hoa hồng",
			dingdanyongjing:"Phương pháp đóng",
			shoudongpingcang:"Hoa hồng đặt hàng",
			qiangzhipingcang:"Đóng thủ công",
			gendanpingcang:"Buộc thanh lý",
			baocang:"Thanh lý",
			yuguqiangpingjia:"Thực hiện theo lệnh để đóng một vị trí",
			kaicangdiqu:"Giá ngang bằng bắt buộc ước tính",
			ispingcang:"Khu vực mở cửa",
			tips:"Bạn có chắc chắn về việc buộc phải thanh lý?",
			pincangsucc:"gợi ý",
			queding:"Vị thế đã đóng thành công",
			cancel:"Chắc chắn",
		},	
	Langswitch: {	
	  "en":"Tiếng Anh",	
	  "id":"tiếng Indonesia",	
	  "th":"Tiếng Thái Lan",	
	  "vi":"Tiếng Việt",	
	  "zh":"người Trung Quốc",	
	  "fa":"người Pháp",	
	  "han":"Hàn Quốc",	
	  "tu":"tiếng Thổ Nhĩ Kỳ",	
	  "pu":"tiếng Bồ Đào Nha",	
	  "xi":"người Tây Ban Nha",	
	  "jp":"tiếng Nhật",	
	  "ar":"tiếng Ả Rập",	
	},	
}		



// WEBPACK FOOTER //
// ./src/i18n/langs/vi.js